import { render } from "./VUEPopupModificaBanda.vue?vue&type=template&id=17c174d2"
import script from "./VUEPopupModificaBanda.vue?vue&type=script&lang=js"
export * from "./VUEPopupModificaBanda.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__